import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {TranslatePipe} from '@ngx-translate/core';
import {ValidationFinding} from '../../model/validation-finding';

@Component({
  selector: 'app-field-warning',
  standalone: true,
  imports: [MatIcon, TranslatePipe],
  templateUrl: './field-warning.component.html',
  styleUrl: './field-warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldWarningComponent {
  @Input() finding: ValidationFinding | null = null;
  /**
   * Ausrichtung des Hovers. `below-start` reicht ueberall dort, wo unter dem Icon Platz im
   * Layout ist. In einer Tabellenzelle mit Scroll-Container beschneidet dieser den Hover —
   * dort verankert `above-end` ihn nach oben und an die rechte Kante.
   */
  @Input() placement: 'below-start' | 'above-end' = 'below-start';

  closeHover(event: Event): void {
    (event.target as HTMLElement | null)?.blur();
  }
}
